
import Vue from "vue";
import { getCurrentUser } from "./auth";
import Header from "./layouts/Header.vue";
import Footer from "./layouts/Footer.vue";
// import ExitButton from "./components/ExitButton.vue";
export default Vue.extend({
  name: "App",
  // components: { ExitButton },
  data: () => ({}),
  components: {
    Header,
    Footer,
  },
  computed: {
    isAuthenticated() {
      return getCurrentUser();
    },
  },
});
